// API Configuration
// Automatically switches based on environment:
// - npm start → development
// - npm run build → production
const IS_PRODUCTION = process.env.NODE_ENV === "production";

const API_CONFIG = {
	BASE_URL: IS_PRODUCTION
		? "https://www.gymnote-api.fr/gymnote"
		: "http://localhost:5288/gymnote",

	TIMEOUT: 30000,
};

export const GOOGLE_CLIENT_ID =
	"343961493802-h3u6al5h7o3v63d441d5123vboqqq4kq.apps.googleusercontent.com";

export default API_CONFIG;
